import { handleActions } from 'redux-actions'
import { PARTNER_TABLE } from './type'
import { createInitialTableState, createReducerFunction, DESC } from '../../../table/state/reducer'


export const initialState = {
    partnerList: [],
    fetching: false,
    error: null,
    ...createInitialTableState(PARTNER_TABLE, 'partner_partner', {
        'partner.created': DESC,
    }, {'limit':5000}),
}


export default handleActions({
    ...createReducerFunction(PARTNER_TABLE),

}, initialState)


// WEBPACK FOOTER //
// ./src/modules/partner/state/search/reducer.js